import styled from 'styled-components';
import { doodles } from '../../styles/decor';

export const SearchArea = styled.div`
    position:relative;
    isolation:isolate;
    padding-bottom:96px;

    &::before{
        content:'';
        position:absolute;
        inset:0 0 auto 0;
        height:560px;
        background:${doodles('#ec1c24', .08)} 0 0 / 220px;
        -webkit-mask-image:linear-gradient(180deg, #000 0%, #000 60%, transparent 100%);
        mask-image:linear-gradient(180deg, #000 0%, #000 60%, transparent 100%);
        z-index:-1;
    }

    .sectionTag{
        display:inline-flex;
        align-items:center;
        gap:8px;
        color:var(--salato-red);
        font-size:12px;
        font-weight:800;
        letter-spacing:.14em;
        text-transform:uppercase;

        &::before{
            content:'';
            width:18px;
            height:3px;
            border-radius:3px;
            background:var(--salato-yellow);
        }
    }

    .contactHero{
        position:relative;
        padding:64px 24px 44px;
        text-align:center;
        animation:contactIn .7s var(--ease-out) both;

        h1{
            margin:12px 0 0;
            font-size:clamp(36px, 5vw, 60px);
            line-height:1.05;
            letter-spacing:-0.035em;
            font-weight:800;
            color:var(--salato-ink);
        }

        p{
            max-width:560px;
            margin:16px auto 0;
            color:var(--salato-muted);
            font-size:18px;
            line-height:1.6;
        }
    }

    @keyframes contactIn{
        from{ opacity:0; transform:translate3d(0, 20px, 0); }
        to{ opacity:1; transform:none; }
    }

    .contactGrid{
        max-width:1140px;
        margin:0 auto;
        padding:0 24px;
        display:grid;
        grid-template-columns:minmax(0, .9fr) minmax(0, 1.1fr);
        gap:24px;
        align-items:start;
    }

    .channels{
        display:flex;
        flex-direction:column;
        gap:12px;
    }

    .channelCard{
        display:flex;
        align-items:center;
        gap:16px;
        padding:16px 18px;
        border-radius:20px;
        background:#fff;
        text-decoration:none;
        color:inherit;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-sm);
        transition:transform .3s var(--ease-out), box-shadow .3s ease;

        &:hover{
            transform:translateY(-3px);
            box-shadow:0 0 0 1px transparent, var(--shadow-md);

            .channelArrow{
                transform:translateX(4px);
                color:var(--salato-red);
            }
        }

        &.featured{
            padding:22px 20px;
            background:linear-gradient(135deg, #25d366 0%, #13a454 100%);
            color:#fff;
            box-shadow:0 18px 36px rgba(19, 164, 84, .28);

            .channelIcon{ background:#fff; }

            .channelText{
                small, em{ color:rgba(255,255,255,.85); }
                strong{ color:#fff; font-size:20px; }
            }

            .channelArrow{ color:#fff; }

            &:hover .channelArrow{ color:#fff; }
        }
    }

    .channelIcon{
        flex-shrink:0;
        width:52px;
        height:52px;
        border-radius:16px;
        display:flex;
        align-items:center;
        justify-content:center;
        background:var(--salato-red-soft);

        img{
            width:28px;
            height:28px;
            object-fit:contain;

            &.tint{
                filter:brightness(0) saturate(100%) invert(17%) sepia(92%) saturate(5235%) hue-rotate(350deg) brightness(93%) contrast(97%);
            }
        }
    }

    .channelText{
        flex:1;
        min-width:0;
        display:flex;
        flex-direction:column;

        small{
            font-size:12px;
            font-weight:700;
            letter-spacing:.06em;
            text-transform:uppercase;
            color:var(--salato-muted);
        }

        strong{
            font-size:17px;
            font-weight:800;
            color:var(--salato-ink);
            overflow-wrap:anywhere;
        }

        em{
            font-style:normal;
            font-size:13px;
            color:var(--salato-muted);
        }
    }

    .channelArrow{
        font-size:20px;
        font-weight:700;
        color:var(--salato-muted);
        transition:transform .25s var(--ease-out), color .2s ease;
    }

    .addressCard{
        display:flex;
        align-items:center;
        justify-content:space-between;
        gap:16px;
        padding:18px 20px;
        border-radius:20px;
        background:var(--salato-header-red);
        color:#fff;
        box-shadow:0 14px 30px rgba(246, 1, 0, .22);

        small{
            display:block;
            font-size:12px;
            font-weight:700;
            letter-spacing:.08em;
            text-transform:uppercase;
            color:var(--salato-yellow);
        }

        strong{
            display:block;
            margin-top:2px;
            font-size:16px;
        }

        span{
            display:block;
            font-size:14px;
            color:rgba(255,255,255,.85);
        }

        a{
            flex-shrink:0;
            height:42px;
            padding:0 16px;
            display:inline-flex;
            align-items:center;
            border-radius:999px;
            background:var(--salato-yellow);
            color:var(--salato-red-strong);
            font-weight:700;
            font-size:14px;
            text-decoration:none;
            transition:transform .25s var(--ease-out);

            &:hover{ transform:translateY(-2px); }
        }
    }

    .formCard{
        padding:32px;
        border-radius:28px;
        background:#fff;
        box-shadow:0 0 0 1px var(--salato-line), var(--shadow-lg);

        h2{
            margin:0;
            font-size:26px;
            font-weight:800;
            letter-spacing:-0.02em;
            color:var(--salato-ink);
        }
    }

    .formLead{
        margin:6px 0 24px;
        color:var(--salato-muted);
        font-size:15px;
    }

    .fieldRow{
        display:grid;
        grid-template-columns:1fr 1fr;
        gap:14px;
    }

    .field{
        display:flex;
        flex-direction:column;
        gap:8px;
        margin-bottom:18px;

        > span{
            font-size:13px;
            font-weight:700;
            color:var(--salato-ink);
        }

        input,
        textarea{
            width:100%;
            padding:13px 16px;
            border:1.5px solid var(--salato-line);
            border-radius:14px;
            background:#fffcfa;
            font-size:15px;
            color:var(--salato-ink);
            outline:none;
            resize:vertical;
            transition:border-color .2s ease, box-shadow .2s ease, background-color .2s ease;

            &::placeholder{ color:#b3aaa6; }

            &:focus{
                border-color:var(--salato-red);
                background:#fff;
                box-shadow:0 0 0 4px rgba(236, 28, 36, .12);
            }
        }
    }

    .chips{
        display:flex;
        flex-wrap:wrap;
        gap:8px;
    }

    .chip{
        height:36px;
        padding:0 14px;
        border:1.5px solid var(--salato-line);
        border-radius:999px;
        background:#fff;
        color:var(--salato-muted);
        font-size:14px;
        font-weight:600;
        cursor:pointer;
        transition:all .2s ease;

        &:hover{
            border-color:var(--salato-red);
            color:var(--salato-red);
        }

        &.active{
            border-color:var(--salato-red);
            background:var(--salato-red);
            color:#fff;
            box-shadow:0 6px 14px rgba(236, 28, 36, .25);
        }
    }

    .formActions{
        display:flex;
        flex-wrap:wrap;
        gap:10px;
        margin-top:6px;
    }

    .whatsButton,
    .ghostButton{
        height:52px;
        padding:0 22px;
        border-radius:999px;
        font-size:15px;
        font-weight:700;
        cursor:pointer;
        display:inline-flex;
        align-items:center;
        justify-content:center;
        gap:10px;
        transition:transform .25s var(--ease-out), box-shadow .25s ease, opacity .2s ease;

        &:disabled{
            opacity:.45;
            cursor:not-allowed;
            transform:none;
        }

        &:not(:disabled):hover{ transform:translateY(-2px); }
    }

    .whatsButton{
        flex:1 1 220px;
        border:0;
        background:#25d366;
        color:#fff;
        box-shadow:0 12px 26px rgba(19, 164, 84, .3);

        img{
            width:26px;
            height:26px;
            padding:3px;
            border-radius:50%;
            background:#fff;
        }
    }

    .ghostButton{
        flex:1 1 160px;
        border:1.5px solid var(--salato-line);
        background:#fff;
        color:var(--salato-ink);

        &:not(:disabled):hover{ border-color:var(--salato-red); color:var(--salato-red); }
    }

    .formDone{
        text-align:center;
        padding:32px 8px;

        p{
            max-width:380px;
            margin:10px auto 24px;
            color:var(--salato-muted);
            line-height:1.6;
        }
    }

    .doneIcon{
        width:64px;
        height:64px;
        margin:0 auto 16px;
        border-radius:50%;
        display:flex;
        align-items:center;
        justify-content:center;
        background:#25d366;
        color:#fff;
        font-size:30px;
        font-weight:800;
        box-shadow:0 12px 26px rgba(19, 164, 84, .3);
        animation:pop .5s var(--ease-out) both;
    }

    @keyframes pop{
        from{ transform:scale(.5); opacity:0; }
        to{ transform:none; opacity:1; }
    }

    @media (max-width:900px){
        padding-bottom:72px;

        .contactHero{ padding:40px 18px 28px; }

        .contactHero p{ font-size:16px; }

        .contactGrid{
            grid-template-columns:1fr;
            padding:0 16px;
        }

        .formCard{
            padding:22px 18px;
            border-radius:22px;
        }

        .fieldRow{ grid-template-columns:1fr; gap:0; }

        .addressCard{
            flex-direction:column;
            align-items:flex-start;
        }
    }
`;
